/**
 * 会员单位展示状态枚举（门户展示状态）
 */
export const MemberUnitShowStatusEnum = {
  // 未提交
  NOT_SUBMITTED: {
    value: '0',
    label: '未提交'
  },
  // 待审核
  AWAITING_REVIEW: {
    value: '1',
    label: '待核验'
  },
  // 通过
  PASSED: {
    value: '2',
    label: '已展示'
  },
  // 未通过
  FAILED: {
    value: '3',
    label: '未展示'
  }
}

/** 状态值 -> 样式 class 后缀 */
const STATUS_CLASS_SUFFIX = {
  [MemberUnitShowStatusEnum.NOT_SUBMITTED.value]: 'not-submitted',
  [MemberUnitShowStatusEnum.AWAITING_REVIEW.value]: 'awaiting-review',
  [MemberUnitShowStatusEnum.PASSED.value]: 'passed',
  [MemberUnitShowStatusEnum.FAILED.value]: 'failed'
}

/**
 * 根据状态值获取展示文案
 * @param {string} status - 状态值 '0'|'1'|'2'|'3'
 * @returns {string}
 */
export function getMemberUnitShowStatusLabel(status) {
  const item = Object.values(MemberUnitShowStatusEnum).find(
    (e) => e.value === String(status)
  )
  return item ? item.label : MemberUnitShowStatusEnum.NOT_SUBMITTED.label
}

/**
 * 根据状态值获取样式 class 后缀（用于 member-status-tag--xxx）
 * @param {string} status - 状态值
 * @returns {string}
 */
export function getMemberUnitShowStatusClassSuffix(status) {
  return (
    STATUS_CLASS_SUFFIX[String(status)] ||
    STATUS_CLASS_SUFFIX[MemberUnitShowStatusEnum.NOT_SUBMITTED.value]
  )
}
